import { render } from "./MilestoneTable.vue?vue&type=template&id=b6e2a78a&scoped=true"
import script from "./MilestoneTable.vue?vue&type=script&lang=js"
export * from "./MilestoneTable.vue?vue&type=script&lang=js"

import "./MilestoneTable.vue?vue&type=style&index=0&id=b6e2a78a&lang=scss&scoped=true"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e2a78a"]])

export default __exports__